// @flow
import { useSelector } from "react-redux";
import { MultiStageForm, Question } from "../components/MultiStageForm";
import { Email, Name, PersonalInformationAlreadySaved } from "../questions";
import { usePersonalInformationOnSubmit } from "./usePersonalInformationOnSubmit";

export const ExploreMarketTrendsForm = () => {
  const { onSubmit, errorMessage, setErrorMessage } =
    usePersonalInformationOnSubmit({
      leadScore: () => "ZERO",
    });

  const previouslyCreatedDealId = useSelector(
    (state) => state.onboardingForm.dealId,
  );

  if (previouslyCreatedDealId) {
    return <PersonalInformationAlreadySaved />;
  }

  return (
    <MultiStageForm
      onSubmit={onSubmit}
      submitError={errorMessage}
      setSubmitError={setErrorMessage}
      lastButtonLabel="Finish"
    >
      <Question
        route="/get-started/explore-market-trends"
        component={Email}
        name="email"
      />
      <Question
        route="/get-started/explore-market-trends/name"
        component={Name}
        name="name"
      />
    </MultiStageForm>
  );
};
